<template>
  <div class="payment-form-container">
    <InfoContainer
      id="basicForm"
      :infoTitle="formInfo['infoTitle']"
      :contentConfig="formInfo['infoContent']"
    >
      <template #investInfo>
        <CommonDetail v-if="$route.params.id && !editStatus" :configArray="detailConfig" :initValue="investData" />
        <avue-form
          v-else
          ref="paymentInfo"
          v-model="investForm"
          :option="investFormConfig"          
        >
          <template #contractId>
            <CommonSelect
              bindLabel="contractName"
              bindKey="id"
              bindValue="contractName"
              dataUrl="bl/blcontractmanage/searchList"
              methods="get"
              dataMethod="params"
              searchKey="contractName"
              placeholder="请选择合同"
              :bindId="selectContractId?selectContractId:''"
              @handleChange="setContractInfo"
            />
          </template>

          <template #rentId>
            <CommonSelect
              innerKey="id"
              innerKeyName="编号"
              bindLabel="name"
              bindKey="id"
              bindValue="name"
              methods="get"
              dataMethod="params"
              dataUrl="/bl/blcontractrental/page"
              searchKey="name"
              placeholder="请选择报价方案"
              :bindId="rentId?rentId:''"
              @handleChange="setQuotaPlan"
            />
          </template>          

          <template #batchId>
            
            <el-select
              size="small"
              v-model="investForm.batchId"
              clearable
              :disabled="investForm.contractId==''?true:false"
              :placeholder="investForm.contractId==''?'请先选择合同':'请选择放款次号'"
              @change="changeBatch"
            >
              <el-option
                v-for="item in batchList"
                :key="item.id"
                :label="item.tableName"
                :value="item.id">
              </el-option>
            </el-select>
            <!-- <div v-else >{{investData.investBatchStr}}</div> -->
          </template>
        </avue-form>
      </template>

      <template #paymentInfo>
        <CommonDetail :configArray="investInfo" :initValue="investData" />
      </template>
      <template #innerMoney>
        <el-table :data="investData.innerList" border style="width: 100%">
          <el-table-column
            type="index"
            align="center"
            label="序号"
            width="50"
          >
          </el-table-column>
          <el-table-column
            align="center"
            property="moneyType"
            label="款项类型"
          >
            <template slot-scope="scope">
              <div
                class="money-type"
                v-if="scope.row.dictMainOutlayType == 2"
              >
                卖方保证金
              </div>
              <div class="money-type" v-else>
                {{ scope.row.outlayTypeStr }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            property="outlayAmount"
            label="应收金额（元）"
          >
            <template slot-scope="scope">
              {{ getMoney(Number(scope.row.outlayAmount)) }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            property="innerPayment"
            label="当前可内扣金额（元）"
          >
            <template slot-scope="scope">
              {{ getMoney(Number(scope.row.innerPayment)) }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            property="innerMoney"
            label="本次内扣金额（元）"
          >
            <template slot-scope="scope">
              {{ getMoney(Number(scope.row.innerMoney)) }}
            </template>
          </el-table-column>
        </el-table>
      </template>
      <template #paymentPlanTable>
        <EarnoutTable :basicInfoData="basicInfoData"></EarnoutTable>
      </template>
    </InfoContainer>    
  </div>
</template>
<script>
import EarnoutTable from "./earnoutTable";
import * as api from "@/api/factoring/factoringScheme";
import {
  lendingDetail,
} from "@/api/factoring/factoring";
import Accessory from "@/components/accessoriesother/accessory";
import CommonSelect from "@/components/commonSelect/commonSelect";
import CommonDetail from "@/components/commonDetail/commonDetail";
import InfoContainer from "@/components/infoContainer/infoContainer";
import { mapGetters } from "vuex";
import workFlow from "@/mixins/workFlow";
import util from "@/mixins/util";
export default {
  name: 'PaymentPlanForm',
  mixins: [workFlow, util],
  data() {
    return {
      isRequire: false,
      id: '',
      // planList: [],
      investData: {},
      selectContractId: '',
      rentId: '',
      batchList: [],
      // showBatch: false,
      marginList: [],
      innerList: [],
      investForm: {
        contractId: '',
        rentId: '',
        batchId: '',
        planPayDate: ''
      },
      investFormConfig: {
        labelWidth: 130,
        emptyBtn: false,
        submitBtn: false,
        column: [
          {
            label: "合同名称",
            prop: "contractId",
            formslot: true,
            span: 12,
            placeholder: "请选择合同",
          },
          {
            label: "付款次号",
            prop: "batchId",
            formslot: true,
            span: 12,
          },
          {
            label: "报价方案",
            prop: "rentId",
            formslot: true,
            span: 12
          },
          {
            label: "实际付款时间",
            type: "date",
            prop: "planPayDate",
            format: "yyyy-MM-dd",
            valueFormat: "yyyy-MM-dd",
            change: ({column,value})=>{
              this.investForm.planPayDate=value
              this.generatePaymentInfo()
            },
            rules: [{
              required: true,
              message: "请选择计划放款时间",
              trigger: "change",
            }]
          }          
        ]
      },
      formInfo: {
        infoTitle: "新增支付计划",
        infoContent: [
          {
            title: "投放信息",
            prop: "investInfo",
            showBlock: true
          },
          {
            title: "本批次放款信息",
            prop: "paymentInfo",
            showBlock: false
          },
          {
            title: "内扣明细",
            prop: "innerMoney",
            showBlock: false
          },
          {
            title: "支付计划表",
            prop: "paymentPlanTable",
            tips: '（此处“还款日”以“计划放款日期”为参考）',
            showBlock: false
          }
        ]
      },
      detailConfig: [
        {
          label: "合同名称",
          prop: "contractName",
          span: "12",
        },
        {
          label: "放款批次",
          prop: "investBatchStr",
          span: "12",
        },
        {
          label: "报价方案",
          prop: "planName",
          span: "12",
        },
        {
          label: "放款日期",
          prop: "planPayDate",
          span: "12",
        },
      ],
      investInfo: [
        {
          label: "本笔放款金额",
          span: "12",
          prop: "investMoney",
          formatter: (label, value) => {
            return `${this.getMoney(Number(value))}元`;
          },
        },
        // {
        //   label: "计划放款日期",
        //   span: "12",
        //   prop: "rentDate",
        // },
        {
          label: "内扣合计金额",
          span: "12",
          prop: "innerCost",
          formatter: (label, value) => {
            return `${this.getMoney(Number(value))}元`;
          },
        },
        {
          label: "实际应付金额",
          span: "12",
          prop: "investShouldMoney",
          formatter: (label, value) => {
            return `${this.getMoney(Number(value))}元`;
          },
        },
        {
          label: "支付方式",
          span: "12",
          prop: "payType",
          formatter: (label, value) => {
            return value == 0
              ? "电汇"
              : value == 1
              ? "银行承兑汇票"
              : value == 2
              ? "商票"
              : "其它";
          },
        },
        {
          label: "补充说明",
          span: "24",
          prop: "remarks",
        },
      ],     
    }
  },
  props: {
    // 是否在详情页
    editStatus: {
      type: Boolean,
      default: false,
    },
    // 传入的支付计划ID
    editId: {
      type: String,
      default: ''
    },
    bindData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    planList: {
      type:Array,
      default: () => {
        return []
      }
    },
    basicInfoData: {
      type:Object,
      default: () => {
        return {}
      }
    },
  },
  watch: {
    bindData: {
      handler(newData, oldData) {
        // newData.batchId = 
        newData.investBatchStr = `第${newData.investBatch}批/第${newData.paymentBatch}笔`
        this.selectContractId = newData.conManageId
        this.rentId = newData.planId
        this.investData = newData
        this.investData.innerCost = Number(newData.investMoney) - Number(newData.investShouldMoney)
        this.investForm = {
          contractId: newData.conManageId,
          rentId: newData.planId,
          batchId: newData.id,
          planPayDate: newData.planDate
        }
        console.log(newData)
      }
    }
  },
  components: {
    Accessory,
    CommonSelect,
    CommonDetail,
    InfoContainer,
    EarnoutTable
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },  
  mounted() {},
  methods: {
    changeBatch(data) {
      this.generatePaymentInfo()
    },

    async setContractInfo(data) {
      if(JSON.stringify(data) != '{}') {
         this.$emit("setBasicInfoData",data) 

        this.investForm.contractId = data.id
        this.batchParam = { contractId: data.id}
        // 查询批次
        let res = await api.getBatchList({
          id: this.investForm.batchId,
          contractId: data.id
        })
        let batchList = res.data.data
        batchList.map(item => {
          item.tableName = `第${item.investBatch}批/第${item.paymentBatch}笔`
        })
        this.batchList = batchList
        // 判断是否生成本批次放款信息
        this.generatePaymentInfo()
      }
    },

    setQuotaPlan(data) {
      console.log(data)
      if(data && JSON.stringify(data) != '{}') {
        this.investForm.rentId = data.id
        this.generatePaymentInfo()
      }
    },

    async generatePaymentInfo() {
      
      if(!this.isRequire){
        if( this.investForm.contractId != '' &&
            this.investForm.batchId != '' &&
            this.investForm.rentId != '' &&
            (this.investForm.planPayDate != ''&&this.investForm.planPayDate != undefined)
        ) {
          let params = {
            id: this.investForm.batchId,
            rentId: this.investForm.rentId,
            contractId: this.investForm.contractId,
            planPayDate: this.investForm.planPayDate,
          }
          // 生成数据
          this.isRequire = true
          
          let res = await api.generateRentPlan(params)
          if(res.data.code == 200) {
            // this.$router.push({
            //   path: `/factoring/preRepayment/preRepaymentDetail/${res.data.data.id}`
            // })
            // 提示
            this.isRequire = false
            this.$message({
              type: "success",
              message: "计划生成成功",
            });

            this.id = res.data.data
            this.$emit('setId', this.id)
            let planTableRes = await api.getDetailPlanView({ rentId: res.data.data });
            if(planTableRes.data.code == 200) {
              this.planList = planTableRes.data.data.planList
            }

            this.queryLendingInfo(planTableRes.data.data.loadId)
          }
        }
      }

    },

    // 查询放款详情
    async queryLendingInfo(id) {
      let res = await lendingDetail({ id })
      if(res.data.code == 200) {
        this.investData = res.data.data
        this.investData.innerCost = Number(res.data.data.investMoney) - Number(res.data.data.investShouldMoney)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.payment-form-container{
  
}
</style>